import "./App.css";
import "./assets/css/testimonial.css";
import { useEffect, useState } from "react";
import { Header } from "./Header";
import { HomePage } from "./HomePage";
import { Student } from "./pages/Student";
import { StudentList } from "./pages/StudentList";
import { ResponsibleList } from "./pages/ResponsibleList";
import { Training } from "./pages/Training";
import { Accident } from "./pages/Accident";
import { Report } from "./pages/Report";
import { ContactList } from "./pages/ContactList";
import Login from "./pages/Login";
import Signup from "./pages/Signup";
import Logout from "./pages/Logout";
import { Footer } from "./Footer";

import { Routes, Route } from "react-router-dom";
import { Outlet } from "react-router-dom";

import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

function MasterLayout({ token }) {
  const [width, setWidth] = useState(window.innerWidth);

  function handleWindowSizeChange() {
    setWidth(window.innerWidth);
  }

  useEffect(() => {
    window.addEventListener("resize", handleWindowSizeChange);
    return () => {
      window.removeEventListener("resize", handleWindowSizeChange);
    };
  }, []);

  const isMobile = width <= 768;

  return (
    <>
      <Header token={token} />
      <Outlet />
      {!isMobile && <Footer />}
    </>
  );
}

function App() {
  const [token, setToken] = useState("AAAAbbbbCCCCdddd"); //useState(null);
  const notify = () => toast("Wow so easy!");

  // if (!token) {
  //   return <Login setToken={setToken} />;
  // }

  return (
    <Routes>
      <Route path="/" element={<MasterLayout token={token} />}>
        <Route index element={<HomePage />} />
        <Route path="/contatos" element={<ContactList />} />
        <Route path="/aluno" element={<Student />} />
        <Route path="/consultaralunos" element={<StudentList />} />
        <Route path="/consultarresponsaveis" element={<ResponsibleList />} />
        <Route path="/treinamentos" element={<Training />} />
        {token && (
          <Route
            path="/acidente"
            element={<Accident props={notify} token={token} />}
          />
        )}
        {/* <Route path="/relatorio" element={<Report />} />
        <Route path="/login" element={<Login setToken={setToken} />} />
        <Route path="/signup" element={<Signup setToken={setToken} />} />
        <Route path="/logout" element={<Logout setToken={setToken} />} /> */}
      </Route>
    </Routes>
  );
}

export default App;
